export default "__VITE_PUBLIC_ASSET__5a5ccc50__"